import { render, staticRenderFns } from "./HighStateTypesDashboardTable.vue?vue&type=template&id=b9b77e78&scoped=true"
import script from "./HighStateTypesDashboardTable.vue?vue&type=script&lang=js"
export * from "./HighStateTypesDashboardTable.vue?vue&type=script&lang=js"
import style0 from "./HighStateTypesDashboardTable.vue?vue&type=style&index=0&id=b9b77e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b77e78",
  null
  
)

export default component.exports